var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_558_405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5713 4.5H6.07129C5.519 4.5 5.07129 4.94772 5.07129 5.5V10C5.07129 10.5523 5.519 11 6.07129 11H10.5713C11.1236 11 11.5713 10.5523 11.5713 10V5.5C11.5713 4.94772 11.1236 4.5 10.5713 4.5Z",
    stroke: "#B7A5FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.07129 7.5H2.57129C2.30607 7.5 2.05172 7.39464 1.86418 7.20711C1.67665 7.01957 1.57129 6.76522 1.57129 6.5V2C1.57129 1.73478 1.67665 1.48043 1.86418 1.29289C2.05172 1.10536 2.30607 1 2.57129 1H7.07129C7.33651 1 7.59086 1.10536 7.7784 1.29289C7.96593 1.48043 8.07129 1.73478 8.07129 2V2.5",
    stroke: "#B7A5FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_558_405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.571289)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.a2f30d5d2889c60e06d49d85975e90f9.svg";
export { ForwardRef as ReactComponent };